import { InjectableClass } from '@fino/lib-injection';

export class BankSearchController extends InjectableClass {
  value = '';

  constructor(bankSearchService, $timeout) {
    'ngInject';
    super({ bankSearchService, $timeout });
  }

  $onInit() {
    // Set default bind label
    if (!this.bindLabel) this.bindLabel = 'legacyBankIdentifier';

    // Set current model
    if (this.model) {
      this.value = this.model[this.bindLabel];
    }

    this.suggestBank = {
      templateUrl: 'templates/bankSearchSuggest.html',
      editable: true,
      delay: this.delay ? this.delay : 200,
      messages: angular.extend(
        {
          required: 'bank.suggest.message.required',
        },
        this.messages
      ),
    };
  }

  suggestBankSrc(viewValue) {
    return this.bankSearchService.getBanks(viewValue, this.url);
  }

  suggestBankSelect($item) {
    this.onSelect({ $item });
    this.$timeout(() => {
      this.model = $item;
      this.value = this.model[this.bindLabel];
    });
  }

  // reset model, it happened that a customer selected "Sparkasse Kassel" typed again
  // "Sparkasse Kassel Nord" and thought that "Sparkasse Kassel Nord" was selected
  textChange($event) {
    this.model = {};
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-bank-search/src/bankSearch.controller.js